// Load the Tawk.to chat widget in production only.
export const loadTawkTo = () => {
    const allowedEnvironments = ['production'];
    const isAllowedEnv = allowedEnvironments.includes(process.env.REACT_APP_ENV);

    if (!isAllowedEnv) {
        return;
    }

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement('script');
    const s0 = document.getElementsByTagName('script')[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/65d48b428d261e1b5f62afbd/1hn33vvot';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
};
